import { ComponentRef } from '@wix/editor-platform-sdk-types';

import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { createDesignPresetsError, DesignPresetsErrorCode } from './errors';

export class DesignPresetsNamespace extends PrivateAPINamespace {
  static readonly namespace = 'designPresets';

  #getWidgetPresets(compRef: ComponentRef) {
    const stageData = this.ps.ds.appStudioWidgets.getWidgetStageData(compRef);
    const presets = (stageData?.gfpp?.desktop as any).widgetPresets
      ?.presets as {
      id: string;
      name: string;
      src: string;
    }[];

    if (!presets) {
      return [];
    }

    return presets.map((x) => ({
      id: x.id,
      name: x.name,
    }));
  }

  setDesignPreset(compRef: ComponentRef, presetId: string) {
    this.ps.ds.appStudioWidgets.presets.change(
      compRef,
      // stylePresetId:
      presetId,
      // layoutPresetId:
      presetId,
    );
  }

  getDesignPreset(compRef: ComponentRef) {
    return this.ps.ds.appStudioWidgets.presets.get(compRef);
  }

  setDesignPresetByName(compRef: ComponentRef, presetName: string) {
    const presets = this.#getWidgetPresets(compRef);
    const preset = presets.find((x) => x.name === presetName);

    if (!preset || !preset.id) {
      console.warn(
        createDesignPresetsError(DesignPresetsErrorCode.UnknownDesignPreset)
          .withPreset(presetName)
          .withAvailablePresets(presets.map((x) => x.name)),
      );

      return;
    }

    this.setDesignPreset(compRef, preset.id);
  }

  async getDesignPresetName(compRef: ComponentRef) {
    const preset = await this.getDesignPreset(compRef);

    return this.#getWidgetPresets(compRef).find((x) => x.id === preset.layout)
      ?.name;
  }
}
